import { StyledButtonSpinner } from './ButtonSpinner.styles';

interface IButtonSpinnerProps {
  isLightColor?: boolean;
  title?: string;
  description?: string;
  autoFocus?: boolean;
  isInlineSpinnerLoading?: boolean;
}

export const ButtonSpinner = ({
  isLightColor,
  title,
  description,
  autoFocus,
  isInlineSpinnerLoading
}: IButtonSpinnerProps) => {
  const visibleTitle = isInlineSpinnerLoading ? title : '';
  const visibleDescription = isInlineSpinnerLoading ? description : '';

  return (
    <StyledButtonSpinner
      ariaHidden={!isInlineSpinnerLoading}
      autoFocus={autoFocus && isInlineSpinnerLoading}
      data-testid="inlineSpinner"
      description={visibleDescription}
      isLightColor={isLightColor}
      isInlineSpinnerLoading={isInlineSpinnerLoading}
      title={visibleTitle}
    />
  );
};

ButtonSpinner.displayName = 'ButtonSpinner';
